
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';
import ContactDialog from './ContactDialog';

const FinalCTA: React.FC = () => {
  return (
    <section className="py-20 px-6 md:px-10 relative overflow-hidden bg-gray-50 text-gray-900">
      {/* Background Elements with logo */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 right-[15%] w-64 h-64 bg-heading-accent/5 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-1/4 left-[10%] w-72 h-72 bg-heading-secondary/5 rounded-full filter blur-3xl"></div>
        <div className="absolute top-20 left-[30%] w-20 h-20 opacity-20">
          <img src="/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png" alt="Sparkwave AI Icon" className="w-full h-full" />
        </div>
      </div>
      
      <div className="container mx-auto relative z-10">
        <div className="max-w-4xl mx-auto bg-white/80 backdrop-blur-xl border border-gray-200/50 rounded-xl p-10 md:p-16 text-center shadow-soft">
          <div className="inline-block p-4 mb-6 animate-pulse-soft">
            <img src="/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png" alt="Sparkwave AI Logo" className="h-16 w-16" />
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-6 animate-fade-in">
            AI That Drives Results. <span className="text-gradient">Let's Make It Happen.</span>
          </h2>
          
          <p className="text-lg text-gray-700 mb-8 animate-fade-in delay-200">
            Ready to transform your business with AI? Schedule a discovery call today and let's discuss how we can help you achieve your goals.
          </p>
          
          <ContactDialog 
            trigger={
              <Button size="lg" className="btn-hover-effect group animate-fade-in delay-400 bg-heading-accent hover:bg-heading-accent/90 text-white">
                Book a Discovery Call
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            }
          />
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
